export const CONSOLE_PATH = '/consoln/';
export const PUBLIC_HOME_TITLE = 'BoFlow · 官方同款模型，按美元面值付人民币';
export const PUBLIC_HOME_COPY = {
  headline: '一个接口，调用多种主流模型',
  subtitle: '统一兼容接口，让个人开发者和中小团队更简单地接入主流模型，无需分别适配多个平台。',
} as const;

function normalizePath(pathname: string): string {
  return ('/' + pathname).replace(/\/{2,}/g, '/').replace(/\/+$/, '') || '/';
}
export function isConsolePath(pathname: string): boolean {
  const path = normalizePath(pathname);
  return path === '/consoln' || path.startsWith('/consoln/');
}
export type PublicPage = 'home' | 'pricing' | 'docs' | 'status' | 'not-found';
export function publicPageForPath(pathname: string): PublicPage | 'console' {
  if (isConsolePath(pathname)) return 'console';
  const path = normalizePath(pathname);
  if (path === '/') return 'home';
  if (path === '/pricing') return 'pricing';
  if (path === '/docs') return 'docs';
  if (path === '/status') return 'status';
  return 'not-found';
}
